import React from 'react';

import HomeJumbotron from './_homeJumbotron';
import Cards from './_homeCardList';
import Facts from './_homeFactList';

import 'styles/global.scss'

export default (props) => {

    const { factsData, cardsData, jumbotronData } = props
    const jumbotronImg = props.data.jumbotronImg.childImageSharp.sizes;
    const cardsImages = {
        educators: props.data.cardEducatorImg.childImageSharp.sizes,
        learn: props.data.cardLearnImg.childImageSharp.sizes,
        getInvolved: props.data.cardGetInvolvedImg.childImageSharp.sizes
    };

    return (
        <div>
            <div className="wrapper">
                <HomeJumbotron jumbotronData={jumbotronData} image={jumbotronImg} />
            </div>
            <div className="container">
                <Facts factsData={factsData} />
                <Cards cardsData={cardsData} images={cardsImages}/>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/pages/index/_homeLayout.js